import { c as _c } from "react/compiler-runtime";
import { Line } from "react-chartjs-2";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, PointElement, Tooltip } from "chart.js";
import { ChartProps } from "./UserPageStatsActivityTDHHistoryCharts";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, BarElement);
const GRAPH_OPTIONS = {
  scales: {
    x: {
      grid: {
        color: "rgb(45, 45, 45)"
      },
      ticks: {
        color: "rgb(154, 154, 154)"
      }
    },
    y: {
      grid: {
        color: "rgb(45, 45, 45)"
      },
      ticks: {
        color: "rgb(154, 154, 154)"
      }
    }
  },
  plugins: {
    legend: {
      labels: {
        color: "rgb(200, 200, 200)"
      }
    }
  }
};
export default function UserPageStatsActivityTDHHistoryChart(t0) {
  const $ = _c(7);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.title) {
    t1 = <div className="tw-pt-6 tw-px-4 sm:tw-px-6 tw-flex"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">{data.title}</h3></div>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data) {
    t2 = <div className="tw-p-6"><Line data={data} options={GRAPH_OPTIONS} /></div>;
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-bg-iron-950 tw-border tw-border-iron-800 tw-border-solid tw-rounded-xl">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}